<script>
import Header from "@/components/Header.vue"
export default {
    components:{
        Header
    },
}
</script>

<template>
  <Header/>
  <router-view/>
</template>

<style lang="scss">
@import '~bootstrap/scss/bootstrap';
html,
body { 
    height: 100%;
}
#app{
    height: 100%;
}

</style>
